/**
 * SMS invitation loaded inside its own iframe
 */
import ChatStates from '../core/hooks/ChatStates';
import { BaseWidget } from '../core/BaseWidget';
import WidgetTypes from '../core/enums/WidgetTypes';
import WidgetStates from '../core/hooks/WidgetStates';

export default class SMSInvitation extends BaseWidget {
    constructor(options) {
        super(Object.assign(options, { widget: WidgetTypes.SMS, styleName: 'sms' }));
        this.ready();
    }

    ready() {
        super.ready();
        this.create();
    }

    create() {
        super.create();
        const me = this;
        // ZEE: note that we are not using our view engine for sms invite as sms is not a templated view
        const staticContainer = document.createElement('div');
        // staticContainer.innerHTML = this.options.smsNumber + '<a href="http://www.google.com"></a>';
        staticContainer.innerHTML = 'Click Here for SMS Chat<a href=""></a>';

        const container = document.getElementById(this.options.staticSmsContainer);
        if (container) {
            container.appendChild(staticContainer);
            container.onclick = () => {
                me.getSmsService();
            };
            me.handleADA(container, me.getSmsService.bind2(this));
        }
    }

    show() {
        super.show();
    }

    getSmsService() {
        super.getSmsService('SmsContainer');
        this.state.changeState({ toState: WidgetStates.Clicked, value: true });
        this.state.changeState({ toState: ChatStates.SMSClicked, value: true });
    }
}
